.root {
  border: 1px solid var(--color-border, #e4e4e7);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  overflow: hidden;
  padding: 0;
}

.row {
  align-items: baseline;
  border-bottom: 1px solid var(--color-border, #e4e4e7);
  display: flex;
  flex-wrap: wrap;
  gap: 2px 8px;
  padding: 6px 10px;

  &:last-child {
    border-bottom: none;
  }
}

.title {
  color: var(--color-foreground, #18181b);
}

.subtitle {
  color: var(--color-muted-foreground, #71717a);
}
